import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SBT_TEMPLATES_QUERY_KEY} from "../queryKeys";
import {SbtTemplatesRefreshResult} from "./types";

type RefreshSbtTemplatesVariables = {};

const refreshSbtTemplates = async (): Promise<SbtTemplatesRefreshResult> => {
  const response = await axiosReachInstance.post<SbtTemplatesRefreshResult, AxiosResponse<SbtTemplatesRefreshResult>>(
    "/sbt-templates/refresh"
  );
  return response.data;
};

export const useRefreshSbtTemplates = (
  options?: BaseMutationOptions<SbtTemplatesRefreshResult, RefreshSbtTemplatesVariables>
): BaseUseMutationResult<SbtTemplatesRefreshResult, RefreshSbtTemplatesVariables> => {
  return useBaseMutation<SbtTemplatesRefreshResult, RefreshSbtTemplatesVariables>(refreshSbtTemplates, {
    ...options,
    prefixKeysToInvalidate: () => [[SBT_TEMPLATES_QUERY_KEY]],
  });
};
